import { render, staticRenderFns } from "./v_student.vue?vue&type=template&id=ee0a43da&"
import script from "./v_student.vue?vue&type=script&lang=js&"
export * from "./v_student.vue?vue&type=script&lang=js&"
import style0 from "./v_student.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports